const randomString = require("randomstring");

const randomNumber = (number = 10) => {
  return randomString.generate(number) + Math.floor(Math.random() * 9999);
};

export default randomNumber;

